<template>
  <div class="box">
    <swiper :options="swiperOption" v-if="list && list.length">
      <swiper-item
        class="swiper-slide"
        v-for="(item, index) in list"
        :key="index"
      >
        <img
          :src="item.imgUrl"
          width="100%"
          height="100%"
          alt="活动图片"
          @click="clickImg(index)"
        />
      </swiper-item>
      <!-- 分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperItem } from 'vue-awesome-swiper'
export default {
  props: ['list'],
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          delay: 2000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        speed: 800,
        loop: true
      }
    }
  },
  components: {
    swiper,
    swiperItem
  },
  methods: {
    clickImg(index) {
      this.$emit('clickImg', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  box-sizing: border-box;
}
.swiper-container {
  width: 100%;
  height: 137px;
  border-radius: 7px;
}
.swiper-container::v-deep .swiper-slide {
  width: 347px;
  height: 137px;
}
.swiper-container::v-deep .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0;
}
</style>
